import useStores from './useStores';
import { hasFunctionCoin, insertURLQuery } from '~/utils';
import siteRouterManager from '~/utils/site-router';

const useBusinessLink = () => {
    const { corpUserStore } = useStores();

    /**
     * 商务咨询页面：升级版本、增购功能、续费链接
     */
    const getPurchaseLink = () => {
        const link = window.jdy_config.link.customize_better_version;
        if (!link) {
            return '';
        }

        return insertURLQuery(link, [{ key: 'ext', value: corpUserStore.tenantId }]);
    };

    /**
     * 上传凭证页面
     * @see FXD-57266
     */
    const getUploadCertificateLink = () => {
        const link = window.jdy_config.link.upload_certificate;
        if (!link) {
            return '';
        }

        return insertURLQuery(link, [{ key: 'ext', value: corpUserStore.tenantId }]);
    };

    /**
     * 云币充值链接
     * 1、集成模式用户不能自己充值
     * 2、如果没有云币功能，则返回商务页面
     * @see FXD-49577 FXD-65167
     */
    const getPurchaseCoinLink = () => {
        if (corpUserStore?.isIntegratedCorpType || !hasFunctionCoin()) {
            return getPurchaseLink();
        }
        return siteRouterManager.getPurchaseCoinLink();
    };

    return {
        purchaseLink: getPurchaseLink(),
        uploadCertificateLink: getUploadCertificateLink(),
        purchaseCoinLink: getPurchaseCoinLink()
    };
};

export default useBusinessLink;
